import { Component } from '@angular/core';

@Component({
    selector: 'aplifit',
    template: require('./aplifit.component.html'),
})

export class AplifitComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/aplifit/aplifit.component.ts
 **/